import { data } from '../../svg/QuestionMark/data';
import { makeIcon } from '../makeIcon';

export const QuestionMark = makeIcon(data, 'question_mark', 'QuestionMark');

export default QuestionMark;
